import { ThemeType } from '../types/theme.types';
export const THEME_STORAGE_KEY = 'app_theme';
export const getStoredTheme = (): ThemeType => {
  return (localStorage.getItem(THEME_STORAGE_KEY) as ThemeType) || 'dark';
};
export const setStoredTheme = (theme: ThemeType): void => {
  localStorage.setItem(THEME_STORAGE_KEY, theme);
};